import { CopyItem } from '@/components/valuePropList';

import { stressAndAnxietyMessages } from '../../ConfigData/MessageSets';
import {
	howOftenTiles,
	stressCurrentStateTiles,
	stressIdealStateTiles,
} from '../../ConfigData/QuestionTileSets';
import { SignupScreens } from '../../PreSignupProvider/types';

export const stressValueProps: Array<CopyItem> = [
	{
		id: 'valueProp1',
		header: stressAndAnxietyMessages.valueProp1Head,
		body: stressAndAnxietyMessages.valueProp1Body,
	},
	{
		id: 'valueProp2',
		header: stressAndAnxietyMessages.valueProp2Head,
		body: stressAndAnxietyMessages.valueProp2Body,
	},
	{
		id: 'valueProp3',
		header: stressAndAnxietyMessages.valueProp3Head,
		body: stressAndAnxietyMessages.valueProp3Body,
	},
];

export const stressQuestionnaireScreens_NoLanding: SignupScreens = {
	start: {
		componentName: 'PollSingleClickUpdated',
		analyticsName: 'FTUE : Intro Questions',
		questionType: 'mood_question',
		nextScreen: 'q2',
		tiles: howOftenTiles,
		question: stressAndAnxietyMessages.question1,
		questionSubtitle: stressAndAnxietyMessages.question1sub,
		showNav: true,
		backButtonHidden: true,
		bgColor: 'gray0',
		canExit: false,
		questionNumber: 1,
		totalQuestions: 3,
		hasSkip: true,
		skipToEndOverride: 'su',
		hasPadding: false,
		URLKey: 'q1',
	},
	q1: {
		componentName: 'PollSingleClickUpdated',
		analyticsName: 'FTUE : Intro Questions',
		questionType: 'mood_question',
		nextScreen: 'q2',
		tiles: howOftenTiles,
		question: stressAndAnxietyMessages.question1,
		questionSubtitle: stressAndAnxietyMessages.question1sub,
		showNav: true,
		backButtonHidden: true,
		bgColor: 'gray0',
		canExit: false,
		questionNumber: 1,
		totalQuestions: 3,
		hasSkip: true,
		skipToEndOverride: 'su',
		hasPadding: false,
		URLKey: 'q1',
	},
	q2: {
		componentName: 'PollSingleClickUpdated',
		analyticsName: 'FTUE : Intro Questions',
		questionType: 'mood_question',
		nextScreen: 'q3',
		tiles: stressCurrentStateTiles,
		question: stressAndAnxietyMessages.question2,
		questionSubtitle: stressAndAnxietyMessages.question2sub,
		showNav: true,
		backButtonHidden: true,
		bgColor: 'gray0',
		canExit: false,
		questionNumber: 2,
		totalQuestions: 3,
		hasSkip: true,
		skipToEndOverride: 'su',
		hasPadding: false,
		URLKey: 'q2',
	},
	q3: {
		componentName: 'PollSingleClickUpdated',
		analyticsName: 'FTUE : Intro Questions',
		questionType: 'mood_question',
		nextScreen: 'su',
		tiles: stressIdealStateTiles,
		question: stressAndAnxietyMessages.question3,
		questionSubtitle: stressAndAnxietyMessages.question3sub,
		showNav: true,
		backButtonHidden: true,
		bgColor: 'gray0',
		canExit: false,
		questionNumber: 3,
		totalQuestions: 3,
		hasSkip: true,
		skipToEndOverride: 'su',
		hasPadding: false,
		URLKey: 'q3',
	},
	su: {
		componentName: 'SimplifiedSignup',
		analyticsName: 'SimplifiedSignup',
		backButtonHidden: true,
		showNav: false,
		isFullScreen: true,
		upsellImage: true,
		upsellQuizResultComponent: 'SignUpQuizResult',
		canExit: true,
		URLKey: 'su',
	},
	pay: {
		componentName: 'SimplifiedSignup',
		analyticsName: 'SimplifiedSignup',
		backButtonHidden: true,
		showNav: false,
		isFullScreen: true,
		upsellImage: true,
		upsellQuizResultComponent: 'SignUpQuizResult',
		canExit: true,
		URLKey: 'pay',
	},
};
